.section {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.heading {
  margin: 0;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.toggle {
  align-self: flex-start;
}
